module.exports = __webpack_public_path__ + "img/01_noff_close_L3.062078e0.svg";